import { render, staticRenderFns } from "./HumanResources.vue?vue&type=template&id=1460735c&"
import script from "./HumanResources.vue?vue&type=script&lang=js&"
export * from "./HumanResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports